export const PERMS = {
    READ: 'report_vehicle_results.read',
    UPDATE: 'report_vehicle_results.update',
    DELETE: 'report_vehicle_results.delete',
    CREATE: 'report_vehicle_results.create',
    EXPORT: 'report_vehicle_results.export',
}
